export const nl_NL = {
    "PREFIX": {
        "QUESTION": "Vraag",
        "QUESTION-PART": "Vraag",
        "PRE-RELEASE": "Document de préparation",
        "JOURNAL": "Journal"
    },
    "CONTENT": {
        "MARK": "{{totalMarks > 1 && 'merken' || 'mark'}}"
    }
};